module.exports = __webpack_public_path__ + "img/debtPayingAbility8.4338f932.png";